import AGREGAR_MUNICIPIO from '@/graphql/mutations/administracion/catalogos/municipios/agregarMunicipio.gql';
import ENTIDADES from '@/graphql/querys/administracion/catalogos/entidades/entidades.gql';
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import ACTUALICAR_MUNICIPIO from '@/graphql/mutations/administracion/catalogos/municipios/actualizarMunicipio.gql';
import REMOVER_MUNICIPIO from '@/graphql/mutations/administracion/catalogos/municipios/removerMunicipio.gql';

export default {
  apollo: {
    entidades: {
      query: ENTIDADES,
    },
    municipios: {
      query: MUNICIPIOS,
    },
  },
  methods: {
    async mixAgregarMunicipio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_MUNICIPIO,
        variables: {
          municipio: this.municipio,
        },
        update: (store, { data: { agregarMunicipio } }) => {
          const data = store.readQuery({ query: MUNICIPIOS });
          data.municipios.push(agregarMunicipio);
          store.writeQuery({ query: MUNICIPIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarMunicipio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALICAR_MUNICIPIO,
        variables: {
          id: this.municipioEditar.id,
          municipio: this.municipio,
        },
        update: (store, { data: { actualizarMunicipio } }) => {
          const data = store.readQuery({ query: MUNICIPIOS });
          const { municipios } = data;
          const index = municipios
            .findIndex((municipio) => municipio.id === actualizarMunicipio.id);
          if (index !== -1) {
            municipios.splice(index, 1, actualizarMunicipio);
          }
          store.writeQuery({ query: MUNICIPIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarMunicipio() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_MUNICIPIO,
        variables: {
          id: this.municipioEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: MUNICIPIOS });
          const { municipios } = data;
          const index = municipios
            .findIndex((municipio) => municipio.id === this.municipioEliminar.id);
          if (index !== -1) {
            municipios.splice(index, 1);
          }
          store.writeQuery({ query: MUNICIPIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
